import React, { useMemo } from 'react';
import classNames from 'classnames';
import Skeleton from '../../components/Skeleton/Skeleton';
import { useGamesLimit } from '../../hooks/useGamesLimit';
import { createMockEntitiesArray } from '../../../utils/collectionAdapters';

import styles from './GamesWidgetSkeleton.module.css';

export const gameSkeletonItemTestId = 'games-skeleton-item';

export const GamesSkeletonItem = () => {
  return (
    <Skeleton
      className={classNames(styles.card, styles['game-card-item'])}
      dataTestId={gameSkeletonItemTestId}
    />
  );
};

export const GamesWidgetSkeleton = ({ className, limit }) => {
  const defaultLimit = useGamesLimit();
  const customLimit = limit ?? defaultLimit;

  const collection = useMemo(
    () => createMockEntitiesArray(customLimit),
    [customLimit]
  );

  return (
    <div className={classNames(className)}>
      <Skeleton className={styles.title} />
      <div className={styles.grid}>
        {collection.map((item) => (
          <div key={item.id} className={styles.cardWrapper}>
            <GamesSkeletonItem />
          </div>
        ))}
      </div>
    </div>
  );
};
